import { render, staticRenderFns } from "./ArticleBrowser.vue?vue&type=template&id=1ce63015&scoped=true&"
import script from "./ArticleBrowser.vue?vue&type=script&lang=js&"
export * from "./ArticleBrowser.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBrowser.vue?vue&type=style&index=0&id=1ce63015&prod&scoped=true&lang=scss&"
import style1 from "./ArticleBrowser.vue?vue&type=style&index=1&id=1ce63015&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce63015",
  null
  
)

export default component.exports